import moment from 'moment';
import { getPaymentFrequencyKey, getPricingForFrequency } from "../../utility/comparator";

export default ngModule => {

    ngModule.controller('QuoteCtrl', function (AonApi, AonApplicationService, AonConfig, $state, $stateParams, ZohoService) {

        const { leadId, priceId, phone } = $stateParams;

        //Giveback Initiative required check
        const currentDate = new Date();
        const DateUpper = new Date(2023, 3, 31);
        const DateLower = new Date(2022, 10, 1);

        if(currentDate <= DateUpper && currentDate >= DateLower) {
            this.GBICheck = true;
        } else {
            this.GBICheck = false;
        }

        this.loading = true;
        this.error = false;
        this.template = null;
        this.leadId = leadId;
        this.isBroker = AonConfig.corporate.distribution_type === 'broker' || false;
        
        this.formatNumber = (val, numDecimals) => Number(val).toLocaleString([], {
            maximumFractionDigits: numDecimals,
        });

        if (!priceId) {
            this.error = true
        }

        this.onApply = () => {
            const applyCorporate  = this.applicant.zoho.apply_corporate;
            let applicationLink = _.get(this.applicant, 'quote_details.application_link')
            if (applicationLink && !applicationLink.split('://')[1].startsWith(window.location.hostname)) {
                const publicDomain = _.get(this.applicant, 'application_domains.public')
                const agentDomain = _.get(this.applicant, 'application_domains.agent')
                applicationLink = applicationLink.replace(agentDomain, publicDomain);
                window.location.href = applicationLink;
            }
            else if (applyCorporate) {
                window.location.href = `/${applyCorporate}/#/zoho/${leadId}?price=${priceId}`;
            }
            else {
                $state.go(`comparator.step3.${this.pkg.fund.code}`);
            }
        };
        
        this.onShowTerms = () => {
            $('#fund-offer-terms').modal();
        };

        // Get current or future prices at the applicants selected payment frequency
        const frequencyPrices = (pkg, which) => {
            let frequencyPrice = null;
            let frequencyPriceDD = null;
            let frequencyLHCPercent = null;
            let frequencyLHCAmount = null;
            let frequencyLabel = null;
            let paymentFrequency = _.get(this.applicant, 'payment.frequency', null);
            if (paymentFrequency === null || paymentFrequency === undefined) {
                // Default to monthly if no payment frequency is set
                paymentFrequency = AonConfig.jsConstants.PaymentFrequencies.Monthly;
            }
            const frequencyPricingDD = getPricingForFrequency(pkg, which, paymentFrequency, true, false);
            frequencyPrice = getPricingForFrequency(pkg, which, paymentFrequency, false, false).premium.toFixed(2);
            frequencyPriceDD = frequencyPricingDD.premium.toFixed(2);
            frequencyLabel = getPaymentFrequencyKey(paymentFrequency);
            frequencyLHCPercent = frequencyPricingDD.lhc_percent;
            frequencyLHCAmount = frequencyPricingDD.lhc_amount;
            return {
                frequencyPrice,
                frequencyPriceDD,
                frequencyLabel,
                frequencyLHCPercent,
                frequencyLHCAmount,
            };
        };

        const setPricingOnScope = (pkg) => {
            const pricing = pkg.price.pricing.available;
            const discounts = pricing.monthly_adjusted_price.discounts;
            const rebatePercent = pricing.monthly_adjusted_price.rebate_percent.toFixed(3);
            const monthlyPrice = pricing.monthly_adjusted_price.premium.toFixed(2);
            const monthlyPriceDD = pricing.monthly_adjusted_price_dd_discount.premium.toFixed(2);
            const fortnightlyPrice = pricing.fortnightly_adjusted_price.premium.toFixed(2);
            const fortnightlyPriceDD = pricing.fortnightly_adjusted_price_dd_discount.premium.toFixed(2);

            const hasDiscount = monthlyPrice != monthlyPriceDD;
            const showExcess = pkg.price.type !== AonConfig.jsConstants.ProductPriceType.ANCILLARY;
            const {
                frequencyPrice,
                frequencyPriceDD,
                frequencyLHCPercent,
                frequencyLHCAmount,
                frequencyLabel,
            } = frequencyPrices(pkg, 'available');

            const currentAvailableTo = moment(pricing.available_to);

            this.pricing = {
                rebatePercent,
                monthlyPrice,
                fortnightlyPrice,
                monthlyPriceDD,
                fortnightlyPriceDD,
                frequencyPrice,
                frequencyPriceDD,
                frequencyLHCPercent,
                frequencyLHCAmount,
                frequencyLabel,
                hasDiscount,
                discounts,
                showExcess,
            };

            this.pricing.currentAvailableTo = currentAvailableTo.format('MMMM Do YYYY');

            if (pkg.price.pricing.future) {
                const availableFrom = moment(pkg.price.pricing.future.available_from);
                const monthlyFuturePrice = pkg.price.pricing.future.monthly_adjusted_price.premium.toFixed(2);
                const monthlyFuturePriceDD = pkg.price.pricing.future.monthly_adjusted_price_dd_discount.premium.toFixed(2);
                const fortnightlyFuturePrice = pkg.price.pricing.future.fortnightly_adjusted_price.premium.toFixed(2);
                const fortnightlyFuturePriceDD = pkg.price.pricing.future.fortnightly_adjusted_price_dd_discount.premium.toFixed(2);
                const { frequencyPrice, frequencyPriceDD, frequencyLabel } = frequencyPrices(pkg, 'future');
                const hasFutureDiscount = monthlyFuturePrice != monthlyFuturePriceDD;
                this.pricing.availableFrom = availableFrom.format('MMMM Do YYYY');
                this.pricing.futurePremium = hasFutureDiscount ? monthlyFuturePriceDD : monthlyFuturePrice;
                this.pricing.futureDiscount = hasFutureDiscount;
                this.pricing.futureFortnightlyPremium = hasFutureDiscount ? fortnightlyFuturePriceDD : fortnightlyFuturePrice;
                this.pricing.futureFrequencyPremium = hasFutureDiscount ? frequencyPriceDD : frequencyPrice;
                this.pricing.futureFrequencyLabel = frequencyLabel;
            }
        };

        ZohoService.getZohoApplicant(leadId, null, 'Trigger: View Quote')
            .then(() => {
                return AonApplicationService.getApplication();
            })
            .then((applicant) => {
                this.applicant = applicant;
                this.quoteClass = applicant.zoho.company_id.replace(/[^a-zA-Z]/, '');
                this.disableApply = applicant.zoho.stage_is_closed;
                const template = applicant.zoho.company_template;
                const errorTemplate = applicant.zoho.company_error_template;
                this.template = `/static/partials/quote/${template}`;
                this.errorTemplate = `/static/partials/quote/${errorTemplate}`;
                if (this.applicant.zoho.company_contact_number) {
                    this.contact_number = this.applicant.zoho.company_contact_number;
                }
                if (phone) {
                    // Override with operator phone number if it was passed as a url parameter
                    this.contact_number = phone;
                }
                if (this.contact_number) {
                    this.contact_number_tel_link = this.contact_number.replace(/\s/g, '');
                }
                if (this.applicant.fund_specific_data.quote_entry_date) {
                    // display as DD MM YYYY
                    this.quote_entry_date = moment(this.applicant.fund_specific_data.quote_entry_date).format('DD MMM YYYY');
                }
                return AonApi.fetchPrice(applicant, priceId);
            })
            .then(({data: pkg}) => {
                this.pkg = pkg;
                this.fundOffer = AonConfig.corporate.general_offers[pkg.fund.code];
                const price = pkg.price;
                pkg.selectedPrice = price;
                AonApplicationService.setProduct(pkg);
                AonApplicationService.setPrice(price);
                _.set(this.applicant, 'policy.membership_type', price.membership_type);
                _.set(this.applicant, 'primary_address.state', price.state);
                AonApplicationService.saveApplication(this.applicant);
                setPricingOnScope(pkg);

                const zoho = _.get(this.applicant, 'zoho', {});
                this.isNewToPHI = !_.get(this.applicant, 'personal.previous_fund.has_previous_fund', false);
                this.showImprovedBenefitsExpectedSavings = Number(zoho.expected_yearly_savings) > 0;
                this.hasImprovedBenefits = (
                    zoho.improved_benefit_1 ||
                    zoho.improved_benefit_2 ||
                    zoho.improved_benefit_3
                );
                this.showImprovedBenefitsTable = (
                  AonConfig.corporate.show_additional_details_on_quote &&
                  (this.showImprovedBenefitsExpectedSavings || this.hasImprovedBenefits)
                );
                this.loading = false;
            })
            .catch((error) => {
                this.error = true;
                this.loading = false;
            });

    });
};



// WEBPACK FOOTER //
// ./src/controllers/comparator/quote-ctrl.js